export const TETProductManagementFields = {
  country: {
    name: "Country",
    value: "",
    rules: { title: "Country", required: true },
  },
  ProductName: {
    name: "Product Name",
    value: "",
    rules: { title: "Product Name", required: true },
  },
  ShowInList: {
    name: "Show In List",
    value: "",
    rules: { title: "Show In List", required: true },
  },
  TETType: {
    name: "TET Type",
    value: "",
    rules: { title: "TET Type", required: true },
  },
  TETProductName: {
    name: "TET Product Name",
    value: "",
    rules: {
      title: "TET Product Name",
      required: { required: false },
    },
    display: false,
  },
};

export const TETContentManagementFields = {
  country: {
    name: "Country",
    value: "",
    rules: { title: "Country", required: true },
  },
  userType: {
    name: "User Type",
    value: "",
    rules: { title: "User Type", required: true },
  },
  language: {
    name: "Language",
    value: "",
    rules: { title: "Language", required: true },
  },
  content: {
    name: "Content",
    value: "",
    rules: { title: "Content", required: true },
  },
};
export const TETContentUserTypeOptions = [
  { value: "HCP / Employee", label: "HCP / Employee" },
  { value: "Patient", label: "Patient" },
];

export const TETRulesConfigurationFields = {
  country: {
    name: "Country",
    value: "",
    rules: { title: "Country", required: true },
  },
  userType: {
    name: "User Type",
    value: "",
    rules: { title: "User Type", required: true },
  },
  language: {
    name: "Language",
    value: "",
    rules: { title: "Language", required: true },
  },
  product: {
    name: "Product",
    value: "",
    rules: { title: "Product", required: true },
  },
};
export const AddTetProductFields = {
  affiliate: {
    name: "Affiliate",
    value: "",
    rules: { title: "Affiliate", required: true },
  },
  tetProduct: {
    name: "TET Product",
    value: "",
    rules: { title: "TET Product", required: true },
  },
};



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/TET/Field.js